<template>
  <v-row justify="center">
    <v-dialog v-model="active" persistent scrollable max-width="500">
      <ValidationObserver ref="obs" v-slot="{ invalid, passes }">
        <v-card :loading="loading">
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                {{
                  value === 0 ? "Nueva tipificación" : "Actualizar tipificación"
                }}
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 350px">
              <v-form>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider
                      <ValidationProvider
                      name="nombre"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Nombre"
                        name="nombre"
                        prepend-inner-icon="mdi-account"
                        type="text"
                        color="blue-grey"
                        v-model="data.name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="$emit('dialog:change', 'cerrar')"
                >Cancelar</v-btn
              >
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                dark
                rounded
                :loading="loading"
                :disabled="loading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="
                  () => {
                    value === 0 ? passes(register) : passes(update);
                  }
                "
              >
                {{ value === 0 ? "Añadir" : "Actualizar" }}
              </v-btn>
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import vuescroll from "vuescroll";
import { parse } from "path";

export default {
  props: ["active", "data", "value"],

  components: {
    vuescroll,
  },

  data() {
    return {
      search: "",
      dialog: false,
      loading: false,
      cola: [],
    };
  },

  created() {
    // this.getColas();
  },

  methods: {
    resetform() {
      this.$refs.obs.reset();
    },

    // async getColas() {
    //   try {
    //     const response = await this.$store.dispatch("queue/SHOW_QUEUE");
    //     this.cola = response.data.data;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    async register() {
      try {
        this.loading = true;
        // console.log(this.data);
        const enviar = {
          name: this.data.name,
          queue_id: this.data.queue_id,
        };
        const response = await this.$store.dispatch(
          "typifications/REGISTER_TYPIFICATIONS",
          enviar
        );
        this.loading = false;
        this.resetform();
        let message = response.data.message;
        this.$emit("dialog:change", message);
      } catch (error) {
        alert(error);
      }
    },
    async update() {
      try {
        this.loading = true;
        const enviar = {
          data: {
            name: this.data.name,
            number: parseInt(this.data.number),
          },
          id: this.data.id,
        };
        const response = await this.$store.dispatch("queue/EDIT_QUEUE", enviar);
        this.loading = false;
        this.resetform();
        let message = response.data.message;
        this.$emit("dialog:change", message);
      } catch (error) {
        console.log(error);
      }
    },
    eventdialog() {
      this.activeAlert = false;
    },
  },
};
</script>
